import script from "./LuceneExpressionFixButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LuceneExpressionFixButton.vue?vue&type=script&setup=true&lang=js"

import "./LuceneExpressionFixButton.vue?vue&type=style&index=0&id=77972e96&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77972e96"]])

export default __exports__